(function () {
  var roots = document.querySelectorAll('[data-lp-root]');
  if (!roots.length) return;
  roots.forEach(function (r) { r.classList.add('lp-anim'); });

  var reveals = document.querySelectorAll('.lp-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.14, rootMargin: '0px 0px -5% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else { reveals.forEach(function (el) { el.classList.add('is-in'); }); }

  var header = document.querySelector('[data-lp-header]');
  var sticky = document.querySelector('[data-sticky]');
  function onScroll() {
    var y = window.pageYOffset;
    if (header) header.classList.toggle('is-scrolled', y > 8);
    if (sticky) sticky.classList.toggle('is-on', y > window.innerHeight * 0.85);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  document.querySelectorAll('[data-scroll]').forEach(function (a) {
    a.addEventListener('click', function (ev) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var el = document.getElementById(href.slice(1));
      if (!el) return;
      ev.preventDefault();
      var top = el.getBoundingClientRect().top + window.pageYOffset - 76;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  var faqItems = document.querySelectorAll('[data-faq]');
  faqItems.forEach(function (item) {
    var btn = item.querySelector('[data-faq-q]');
    var panel = item.querySelector('.lp-faq__a');
    if (item.classList.contains('is-open') && panel) panel.style.maxHeight = panel.scrollHeight + 'px';
    btn.addEventListener('click', function () {
      var open = item.classList.contains('is-open');
      faqItems.forEach(function (o) {
        o.classList.remove('is-open');
        var b = o.querySelector('[data-faq-q]'); if (b) b.setAttribute('aria-expanded', 'false');
        var p = o.querySelector('.lp-faq__a'); if (p) p.style.maxHeight = '0px';
      });
      if (!open) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        if (panel) panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
})();


/* ============================================================
   Klaviyo signup wiring (added 2026-07-20)
   Subscribes every .lp-signup__form email on any lander to the
   Telos Master List (list U6qwj4) via Klaviyo's client Subscribe
   API -> triggers the welcome flow. Company URY95k, revision 2025-07-15.
   ============================================================ */
(function () {
  var COMPANY = 'URY95k';
  var LIST = 'U6qwj4';
  function source() {
    var m = (location.search || '').match(/view=lander-([a-z]+)/i);
    return 'Desert Drip Lander' + (m ? ' (' + m[1] + ')' : '') + ' Signup';
  }
  function wire(form) {
    if (form.dataset.klBound) return;
    form.dataset.klBound = '1';
    var input = form.querySelector('input[type=email]');
    var btn = form.querySelector('button[type=submit], .lp-signup__btn');
    if (!input) return;
    var msg = document.createElement('p');
    msg.setAttribute('role', 'status');
    msg.setAttribute('aria-live', 'polite');
    msg.style.cssText = 'margin:2px 0 0;font-family:var(--font-body,sans-serif);font-size:1.4rem;font-weight:700;display:none;';
    form.appendChild(msg);
    function show(t, ok) { msg.textContent = t; msg.style.color = ok ? '#1f5130' : '#8a1f16'; msg.style.display = 'block'; }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { show('Please enter a valid email address.', false); return; }
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Joining...'; }
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(COMPANY), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2025-07-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: source(), profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: LIST } } } } })
      }).then(function (res) {
        if (res.ok) { form.reset(); input.style.display = 'none'; if (btn) btn.style.display = 'none'; show("You're in. Watch your inbox.", true); }
        else { if (btn) { btn.disabled = false; btn.textContent = label; } show('Something went wrong. Please try again.', false); }
      }).catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } show('Something went wrong. Please try again.', false); });
    });
  }
  function init() { var f = document.querySelectorAll('.lp-signup__form'); for (var i = 0; i < f.length; i++) wire(f[i]); }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
